import I18n from "common/i18n";
import { ConfirmMessageBox } from "common/elements";

type Props = {
  showVersionWarning: boolean;
  onCloseVersionWarning: () => void;
  onGotoStoreUpdate: () => void;
};

export const UserPlanWarningDialogs = ({
  showVersionWarning,
  onCloseVersionWarning,
  onGotoStoreUpdate,
}: Props) => {
  return (
    <>
      {showVersionWarning && (
        <ConfirmMessageBox
          title={I18n.t("MSG_USER_PLAN_UPDATE_REQUIRED_TITLE")}
          message={I18n.t("MSG_USER_PLAN_UPDATE_REQUIRED_MESSAGE")}
          close={onCloseVersionWarning}
          confirm={onGotoStoreUpdate}
        />
      )}
    </>
  );
};
